<div class="custom-select" [formGroup]="formGroup">
  <select #selectEl class="select"
      [formControlName]="controlName"
      (change)="OnChange.emit($event);onSelectChange(selectEl)"
      (blur)="onSelectChange(selectEl)"
      *ngIf="!isObject(listOptionsFormated)">

    <option value="" hidden *ngIf="!hasEmptyValue"></option>

    <!-- Usar value o ngValue según returnFullObject -->
    <ng-container *ngIf="!returnFullObject; else objectOptions">
      <option *ngFor="let option of listOptionsFormated" [value]="option.key">
        {{ option.value }}
      </option>
    </ng-container>

    <ng-template #objectOptions>
      <option *ngFor="let option of listOptionsFormated" [ngValue]="option.raw">
        {{ option.value }}
      </option>
    </ng-template>
  </select>

  <select #selectEl class="select"
      [formControlName]="controlName"
      (change)="OnChange.emit($event);onSelectChange(selectEl)"
      *ngIf="isObject(listOptionsFormated)">

    <option value="" hidden *ngIf="!hasEmptyValue"></option>

    <ng-container *ngIf="!returnFullObject; else objectKeyOptions">
      <option *ngFor="let option of listOptionsFormated | keyvalue" [value]="option.key">
        {{ option.value.value }}
      </option>
    </ng-container>

    <ng-template #objectKeyOptions>
      <option *ngFor="let option of listOptionsFormated | keyvalue" [ngValue]="option.value.raw">
        {{ option.value.value }}
      </option>
    </ng-template>
  </select>

  <label class="label" [for]="controlName" *ngIf="label !== ''" [class.active]="shouldLabelFloat()" [ngClass]="{'active': shouldLabelFloat(),'error-highlight': highlightError && control?.invalid && (control.dirty || control.touched)}">
    {{ label }}{{ isRequired ? '*' : '' }}
  </label>

  <div class="underline" [ngClass]="{ 'selected': isFocused }">
    <div class="underline-selected"></div>
  </div>

  <input-error class="error" [id]="id" [control]="control" [message]="customeMessageError"></input-error>
</div>